"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethereumjs_wallet_1 = __importDefault(require("ethereumjs-wallet"));
function ephemeral() {
    var w = ethereumjs_wallet_1.default.generate();
    return {
        privateKey: w.privKey,
        address: '0x' + w.getAddress().toString('hex'),
    };
}
exports.ephemeral = ephemeral;
//# sourceMappingURL=keys.js.map